import _ from 'lodash';

/**
 * Transactions State Enumerator.
 *
 * imported from
 * https://bitbucket.org/exporodev/exporo_trading_platform/src/master/application/Exporo/Trading/src/Datatypes/Enums/TradeStates.php
 */

const TradeStatesEnum = Object.assign({
  // Shared initial states.
  CREATED: 'Created',
  PENDING: 'FundingPending',
  FUNDED: 'FundedReceived',
  // Ethereum dedicated states.
  DELIVERED: 'TokensDelivered',
  // Clearstream dedicated states.
  BREAKDOWN_CREATED: 'BreakdownCreated',
  BREAKDOWN_FINISHED: 'BreakdownFinished',
  // Shared final states.
  FAILED: 'TradeFailed',
  CLOSING: 'WaitClosing',
  CLOSED: 'Closed',
});

Object.freeze(TradeStatesEnum);

function formatField(str) {
  const camelCaseSentence = str.replace(/([-_]\w)/g, g => g[1].toUpperCase());
  const sentence = _.startCase(camelCaseSentence);

  return _.capitalize(sentence);
}

export function tradeStates() {
  return Object.keys(TradeStatesEnum)
    .map(key => ({
      text: formatField(TradeStatesEnum[key]),
      value: TradeStatesEnum[key],
    }));
}

export function cancellableStates() {
  return [
    TradeStatesEnum.CREATED,
    TradeStatesEnum.PENDING,
    TradeStatesEnum.FUNDED,
  ];
}

export function closableStates() {
  return [
    TradeStatesEnum.BREAKDOWN_FINISHED,
  ];
}

export function baaderTransitions() {
  return [
    TradeStatesEnum.PENDING,
    TradeStatesEnum.FUNDED,
    TradeStatesEnum.BREAKDOWN_CREATED,
    TradeStatesEnum.BREAKDOWN_FINISHED,
  ];
}

export default TradeStatesEnum;



// WEBPACK FOOTER //
// ./src/enum/trades/TradeStates.js